<div class="now-feedback-container">
  <now-feedback
    class="col-12 col-xl-8"
    client-id="h-5f4741ef-3091-440c-8e96-c0083605699f"
    subject="'Feedback zur NOW-Weiterbildungssuche'"
    x-api-key="now-content-renderer"
  >
    <h2 slot="header">Wie gefällt Ihnen die &bdquo;mein NOW&ldquo; Weiterbildungssuche?</h2>
  </now-feedback>
</div>
